import React from "react";
import { isProductionEnvironment } from "@remi/environment";
import type { KeyList } from "@remi/types/keyboard";

import { getShortcutString, useMedia } from "../hooks";
import { cn } from "../lib/utils";

type RemiShortcutProps = React.HTMLAttributes<HTMLDivElement> & {
  shortcut: KeyList;
  variant?: "primary" | "destructive";
};

const RemiShortcut = ({ ref, shortcut, className }: RemiShortcutProps & { ref?: React.Ref<HTMLDivElement> }) => {
  const { isMobile } = useMedia();

  if (isMobile) {
    return null;
  }

  const formattedShortcut = getShortcutString(shortcut);

  return (
    <div ref={ref} className={cn(isProductionEnvironment() && "opacity-0", className)}>
      {formattedShortcut}
    </div>
  );
};
RemiShortcut.displayName = "RemiShortcut";

export { RemiShortcut };
